import { createSelector } from 'reselect';

export const makeGetSearchResults = () => createSelector([getSearchResults], x => x);

const getSearchResults = (state, props) => state.companySummaries;

export const getCompaniesFromState = state => state.companies;
